import styled from 'styled-components';

export const InvoicePaymentMethodsLinkContainer = styled.div`
  display: flex;
  justify-content: end;
`;
